export const otp = {
    title:"보안 확인",
    label:"이메일 확인 코드",
    content:"전송된 6자리 코드를 입력하세요.",
    button:"확인",
    backToLogin: "로그인으로 돌아가기",
    receivedCode: "아직 코드를 받지 못하셨나요? 새 코드를 요청하십시오. ",
    seconds: "{seconds} 초",
    receivedCodeYet:"아직 코드를 받지 못하셨나요?",
    resendCode: "코드 재전송"
};
